import { pdfjs } from 'react-pdf';

let workerConfigured = false;

/** Configure pdf.js worker once for agreement embedded viewers (react-pdf). */
export function ensureAgreementPdfWorker() {
  if (workerConfigured || typeof window === 'undefined') {
    return;
  }
  pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url
  ).toString();
  workerConfigured = true;
}

export { pdfjs };
